import moment from "moment";
import {
  Button,
  Card,
  CardContent,
  Stack,
  Snackbar,
  Alert,
  LinearProgress,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import Layout from "../components/layout/Layout";
import { useState, useEffect, useCallback } from "react";
import DeletionModal from "../components/ui/DeletionModal";
import DayLessons from "../components/Lessons/DayLesson";
import getProMapping from "../components/Signups/getProMapping";
import { useNavigate } from "react-router-dom";
import useRefresh from "../components/Refresh/refresh";
import useNoSubscriptionRedirect from "../components/Refresh/noSubscriptionRedirect.tsx";
import RegisterLessonModal from "src/components/CreateEventModal/RegisterLessonModal";

function LessonPage({
  setEventId,
  clubId,
  setGameDate,
  devPort,
  waiverNotifications,
  managerMode,
  setLessonPro,
  setLessonPrice,
  betaMode,
  setPricingTab,
}) {
  let navigate = useNavigate();
  useRefresh(clubId, devPort);
  useNoSubscriptionRedirect(betaMode, clubId, managerMode, devPort);
  const [registerModal, setRegisterModal] = useState(false);
  const [comingGamesString, setComingGamesString] = useState();
  const [startDate, setStartDate] = useState(
    moment(moment().format("YYYY-MM-DD") + "T00:00")
      .utc()
      .format("YYYY-MM-DDTHH:mm")
  ); //'2020-01-01')
  const [lessonDelete, setLessonDelete] = useState();
  const [lessonToDelete, setLessonToDelete] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showOnlyBookedLessons, setShowOnlyBookedLessons] = useState(false);

  //Pro Mapping
  const [proMapping, setProMapping] = useState();
  //const [loadingClubPros, setLoadingClubPros] = useState(true);
  useEffect(() => {
    const player_fetcher = devPort + "player_list/" + clubId + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
  }, [devPort, clubId]);

  const filterGames = useCallback(() => {
    console.log("AAAAAAAAAA");
    if (proMapping) {
      console.log("BBBBBBBBBBB");
      console.log(devPort + "lesson_list/" + clubId + "/" + startDate);
      fetch(devPort + "lesson_list/" + clubId + "/" + startDate)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("DATA");
          console.log(data);
          let newLessons = [];
          var dayLessons = {};
          data.map((lesson) => {
            //const newGames = Object.entries(game) data.map((game) => {
            //Moment is setting the day to one day before when time is 00?
            //return [game[0], game[1], moment(game[3]).add(1, "days").format('YYYY-MM-DD')]
            // TODO: Jeremie to refactor this sketchy thing
            let dateOfGame;
            //let dayLessons = [];
            //data[gameDay].map((lesson) => {
            dateOfGame = moment(lesson[4]).format("MM-DD-YYYY");
            //TODO update with correct columns info
            if (!dayLessons[dateOfGame]) {
              dayLessons[dateOfGame] = [];
            }
            console.log(lesson);
            if (!showOnlyBookedLessons || lesson[8] > 0) {
              dayLessons[dateOfGame].push({
                id: lesson[0],
                //lesson_name: lesson[1],
                //day: moment(lesson[3]).add(1, "days").format("dddd, MMMM Do YYYY"),
                pro: proMapping[lesson[6]],
                proId: lesson[6],
                slots: lesson[7],
                available: lesson[7] - lesson[8],
                time: moment(lesson[4]).format("HH:mm"),
                date: moment(lesson[4]).format("dddd MMMM Do YYYY, HH:mm"),
                lessonPrice: lesson[9] !== "null" ? lesson[9] : null,
                //other: lesson
              });
            }
            return null;
          });
          console.log("THERE");
          console.log(dayLessons);
          Object.keys(dayLessons)
            .sort()
            .map((dateOfGame) => {
              newLessons.push({
                day: moment(dateOfGame, "MM-DD-YYYY").format("dddd"),
                date: dateOfGame,
                lessons: dayLessons[dateOfGame].sort(
                  (a, b) => moment(a.time, "HH:mm") - moment(b.time, "HH:mm")
                ),
              });
              return null;
            });
          if (newLessons.length === 0) {
            let emptyMessage = "available";
            if (showOnlyBookedLessons) {
              emptyMessage = "booked";
            }
            setComingGamesString(
              "No lessons " + emptyMessage + " for the selected week"
            );
          } else {
            setComingGamesString("Upcoming Lessons");
          }
          console.log(newLessons);
          setUpcomingLessons(newLessons);
          setIsLoading(false);
        });
    }
  }, [clubId, devPort, startDate, proMapping, showOnlyBookedLessons]);

  useEffect(() => {
    filterGames();
  }, [filterGames]);

  function deleteLesson(lesson_id) {
    fetch(devPort + "delete_lesson/" + lesson_id, {
      method: "POST",
      credentials: "include",
    }).then((data) => {
      setDeleteModal(false);
      setIsLoading(true);
      filterGames();
      setMessageContent("Lesson has been deleted the schedule!");
      setAlertMessage(true);
    });
  }
  const [alterMessage, setAlertMessage] = useState(false);
  const [messageContent, setMessageContent] = useState(
    "Lesson has been added to the schedule!"
  );
  const [upcomingLessons, setUpcomingLessons] = useState([]);
  /*const [upcomingLessons, setUpcomingLessons] = useState([
    { day: "Monday", date: "10/09/2023", lessons: [] },
    {
      day: "Tuesday",
      date: "10/10/2023",
      lessons: [
        { id: 32, pro: "Santos", slots: 2, available: 1, time: "9:30am" },
        { id: 33, pro: "Doug", slots: 3, available: 1, time: "12:30pm" },
        { id: 34, pro: "Santos", slots: 4, available: 0, time: "2:30pm" },
      ],
    },
  ]);*/
  const numberChukkers = [];
  var i;
  for (i = 1; i <= 10; i++) {
    numberChukkers.push({ label: i, value: i });
  }

  useEffect(() => {
    if (lessonToDelete) {
      setDeleteModal(true);
    }
  }, [lessonToDelete]);

  return (
    <Layout
      managerMode={managerMode}
      waiverNotifications={waiverNotifications}
      devPort={devPort}
    >
      <Snackbar
        open={alterMessage}
        autoHideDuration={3000}
        onClose={() => {
          setAlertMessage(false);
        }}
      >
        <Alert
          severity={
            messageContent.match("does not") || messageContent.match("has not")
              ? "error"
              : "success"
          }
        >
          {messageContent}
        </Alert>
      </Snackbar>

      <Card variant="outlined">
        <CardContent>
          <Stack spacing={3}>
            <DatePicker
              label="Select Week"
              onChange={(event) => {
                const utc_start = moment(
                  moment(event["$d"]).format("YYYY-MM-DD") + "T00:00"
                )
                  .utc()
                  .format("YYYY-MM-DDTHH:mm");
                setStartDate(utc_start);
                console.log(utc_start);
                console.log(event["$d"]);
              }}
            />

            {/*<Grid2 xs={4}>
                <Button
                  variant="contained"
                  size="large"
                  color="success"
                  onClick={filterGames}
                >
                  Show Available Lessons
                </Button>
              </Grid2>
                */}
            <DeletionModal
              deleteModal={deleteModal}
              setDeleteModal={setDeleteModal}
              deleteString="Lesson"
              deleteId={lessonDelete}
              setDeleteId={setLessonToDelete}
              onDelete={() => deleteLesson(lessonToDelete)}
            />
            {managerMode === -1 && (
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  setRegisterModal(true);
                }}
              >
                Create Lesson
              </Button>
            )}
            {managerMode === -1 && (
              <Button
                onClick={() => {
                  setPricingTab("Lesson");
                  navigate("/lessonmanagepricing");
                }}
                variant="outlined"
                size="large"
                color="primary"
              >
                Set Lesson Pricing
              </Button>
            )}

            {!isLoading && (
              <Stack spacing={3}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showOnlyBookedLessons}
                        onChange={(event) => {
                          setShowOnlyBookedLessons(!showOnlyBookedLessons);
                        }}
                      />
                    }
                    label="Only Show Booked Lessons"
                  />
                </FormGroup>
                <h3>{comingGamesString}</h3>
                {upcomingLessons.map((day) => {
                  return (
                    <DayLessons
                      key={day.date}
                      day={day.day}
                      date={day.date}
                      lessons={day.lessons}
                      setLessonDelete={setLessonDelete}
                      setLessonToDelete={setLessonToDelete}
                      managerMode={managerMode}
                      setEventId={setEventId}
                      setLessonPro={setLessonPro}
                      setLessonPrice={setLessonPrice}
                      setGameDate={setGameDate}
                    />
                  );
                })}
                <RegisterLessonModal
                  devPort={devPort}
                  clubId={clubId}
                  proMapping={proMapping}
                  registerModal={registerModal}
                  setRegisterModal={setRegisterModal}
                  setStartDate={setStartDate}
                  onRefresh={filterGames}
                />
              </Stack>
            )}
            {isLoading && <LinearProgress color="secondary" />}
          </Stack>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default LessonPage;
